import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormInputText } from '../sharedComponents/form-components/FormInputText';
import { FormMultilineInputText } from '../sharedComponents/form-components/FormMultilineInputText';
import { upsertClientFlows } from '../../service/ApiService';
import { useLocation } from 'react-router-dom';
import AlertMsg from '../sharedComponents/Alert';

interface IFormInput {
  name: string;
  description: string;
}

export const UpsertFlow = ({
  isResetForm,
  isSubmitForm,
  setIsInvalidForm,
  setFormSubmitted,
  dataToSet
}: {
  isResetForm: boolean;
  isSubmitForm: boolean;
  setIsInvalidForm: (isValid: boolean) => void;
  setFormSubmitted: (isValid: boolean) => void;
  dataToSet?: any;
}) => {
  const { handleSubmit, reset, control, setValue, formState } = useForm<IFormInput>({
    defaultValues: {
      name: '',
      description: '',
    },
    mode: 'onChange',
  });

  const { isValid } = formState;
  const location = useLocation();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertData, setAlertData] = useState<any>();


  useEffect(() => {
    if (dataToSet) {
      setValue('name', dataToSet.flowName);
      setValue('description', dataToSet.description);
    }
  }, [dataToSet, setValue]);

  const openTheSnackbar = () => {
    setOpenSnackbar(true);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  }

  useEffect(() => {
    if (isResetForm) {
      reset();
    }
  }, [isResetForm]);

  useEffect(() => {
    setIsInvalidForm(isValid);
  }, [isValid, setIsInvalidForm]);

  useEffect(() => {
    const featureId: any = new URLSearchParams(location.search).get(
      "featureId"
    )
    if (isSubmitForm) {

      handleSubmit((data: any) => {
        const payload: any = {
          id: dataToSet?.flowId ?? 0,
          clientCode: dataToSet.clientCode,
          featureId: featureId,
          name: data.name,
          description: data.description
        };
        upsertClientFlows(payload)
          .then((response: any) => {
            openTheSnackbar();
            if (response.success) {
              setAlertData({ "type": true, "msg": `The flow has been ${dataToSet?.flowId ? 'updated': 'created'} successfully` });
            } else {
              setAlertData({ "type": false, "msg": response.errorMessage ?? `The flow ${dataToSet?.flowId ? 'updation': 'creation'} was unsuccessful` });
            }
            setTimeout(() => {
              if (response.success) {
                reset();
                setFormSubmitted(true);
              }
            }, 1000);
          })
      })();
    }
  }, [isSubmitForm]);

  return (
    <div>
      <form>
        <FormInputText name="name" control={control} label="Flow Name" required />
        <FormMultilineInputText name="description" control={control} label="Description" />
      </form>

      <AlertMsg openSnackbar={openSnackbar} alertdata={alertData} onClose={handleSnackbarClose}
      />
    </div>
  );
};
